<form [formGroup]="accountsEditForm" >  
    <div class="grid grid-cols-12 gap-3">
        <div class="col-span-12">
            <div class="text-m text-black font-bold uppercase text-center">
                Change Name
            </div>
        </div>
        <div class="col-span-4">
            <div class="card-input flex items-center text-xs py-2 w-full mb-3" [appHighlightOnActive]="true">
                <span class="text-xs w-110-px font-semibold ">
                    First Name:
                </span>
                <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" style="text-transform: capitalize;" formControlName="firstName"  type="text" placeholder="First Name">
            </div>
        </div>
        <div class="col-span-4">
            <div class="card-input flex items-center text-xs py-2 w-full mb-3" [appHighlightOnActive]="true">
                <span class="text-xs w-150-px font-semibold">
                    Middle Name:
                </span>
                <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" style="text-transform: capitalize;" formControlName="middleName"  type="text" placeholder="Middle Name">
            </div>
        </div>
        <div class="col-span-4">
            <div class="card-input flex items-center text-xs py-2 w-full mb-3" [appHighlightOnActive]="true">
                <span class="text-xs w-120-px font-semibold">
                    Last Name:
                </span>
                <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" style="text-transform: capitalize;" formControlName="lastName" type="text" placeholder="Last Name">
            </div>
        </div>
        <div class="col-span-12">
            <hr class="border border-gray-300 w-full my-1 mb-3">
        </div>
        <div class="col-span-12">
            <div class="text-m text-black font-bold uppercase text-center ">
                Change Number
            </div>
        </div>
        <div class="col-span-6">
            <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                <span class="text-xs w-150-px font-semibold">
                    Current Number:
                </span>
                <div class=" focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3  flex items-center italic">
                    {{userName ?? null}}
                </div>
            </div>
        </div>
        <div class="col-span-6">
            <div class="card-input flex items-center text-xs py-2 w-full mb-3" [appHighlightOnActive]="true">
                <span class="text-xs w-150-px font-semibold">
                    New Number:
                </span>
                <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" formControlName="userName"  type="text" placeholder="New Number">
            </div>
        </div>
        <div class="col-span-12">
            <hr class="border border-gray-300 w-full my-1 mb-3">
        </div>
        <div class="col-span-12">
            <div class="text-m text-black font-bold uppercase text-center">
                Change Email
            </div>
        </div>
        <div class="col-span-6">
            <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                <span class="text-xs w-150-px font-semibold">
                    Current Email:
                </span>
                <div class=" focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3  flex items-center italic">
                    {{currentEmail ?? null}}
                </div>
            </div>
        </div>
        <div class="col-span-6">
            <div class="card-input flex items-center text-xs py-2 w-full mb-3" [appHighlightOnActive]="true">
                <span class="text-xs w-120-px font-semibold">
                    New Email:
                </span>
                <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" formControlName="email"  type="email" placeholder="New Email">
            </div>
        </div>
        <div class="col-span-12">
            <hr class="border border-gray-300 w-full my-1 mb-3">
        </div>
        <div class="col-span-12">
            <div class="text-m text-black font-bold uppercase text-center">
                Change Tier
            </div>
        </div>
        <div class="col-span-6">
            <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                <span class="text-xs w-150-px font-semibold">
                    Current Tier:
                </span>
                <div class=" rounded-md py-3 pl-0  minw-200-px flex justify-between items-center h-30-px italic">
                    {{currentTier_text ?? null}}
                </div>
            </div>
        </div>
        <div class="col-span-6">
            <div class="flex items-center">
                <app-custom-dropdown-v2
                    class="w-full"
                    label="Tier Type:"
                    [options]="tierTypeOptions"
                    [selectedText]="tierType_text"
                    placeholder="== Select an option =="
                    (selectionChange)="setTierType($event.label, $event.value)">
                </app-custom-dropdown-v2>
            </div>
        </div>
        <div class="col-span-12">
            <hr class="border border-gray-300 w-full my-1 mb-3">
        </div>
        <div class="col-span-12">
            <div class="text-m text-black font-bold uppercase text-center">
                Change Account Type
            </div>
        </div>
        <div class="col-span-6">
            <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                <span class="text-xs w-150-px font-semibold">
                    Current Account Type:
                </span>
                <div class=" rounded-md py-3 pl-0 minw-200-px flex justify-between items-center h-30-px italic">
                {{currentAccountType_text}}
                </div>
            </div>
        </div>
        <div class="col-span-6">
            <div class="flex items-center">
                <app-custom-dropdown-v2
                    class="w-full"
                    label="Account Type:"
                    [options]="accountTypeOptions"
                    [selectedText]="accountType_text"
                    placeholder="== Select an option =="
                    (selectionChange)="setAccountType($event.label, $event.value)">
                </app-custom-dropdown-v2>
            </div>
        </div>
        <div class="col-span-12  mb-10">
            <div class="w-full flex items-center justify-center mt-10 ">
                <button 
                    appDisableWithoutPermission="*"
                    matTooltip
                    matTooltipClass="custom-orange-tooltip"
                    (click)="update()" 
                    class="uppercase custom-btn btn-dark-orange font-semibold text-xs px-6 py-2"
                >
                    submit
                </button>
            </div>
        </div>
    </div>
</form>